import { useMutation, useQueryClient } from '@tanstack/react-query';
import type {
  ApproveRxChangeRequestT,
  IdentifierResponseT,
} from '@lotushealth/lotushealth_js_sdk/schemas';

import { rxChangeAction } from '../api/rxChangeAction.js';
import { rxKeys } from './keys.js';

export interface ApproveRxChangeVariables {
  rxChangeId: number;
  data: ApproveRxChangeRequestT;
  pendingParams?: {
    detailed?: Parameters<typeof rxKeys.pendingRxChangesDetailed>[0];
  };
}

export function useApproveRxChangeMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['rx', 'rxchanges', 'approve'],
    mutationFn: async ({
      rxChangeId,
      data,
    }: ApproveRxChangeVariables): Promise<IdentifierResponseT> => {
      return await rxChangeAction.approve(rxChangeId, data);
    },
    onSuccess: async (_data, variables) => {
      await queryClient.invalidateQueries({
        queryKey: rxKeys.pendingRxChangesDetailed(variables.pendingParams?.detailed),
      });
    },
  });
}
